import { getElectricityPostpaidTransaction } from '~/api/electricity-postpaid';
import { getInvoices } from '~/api/invoices';
import { humanizeTimestamp } from '~/utils/date-helper';
import { specialMessageSchema, generateSpecialMessage } from '~/utils/special-message-config';
import { CHATBOT_COMMANDS } from '~/utils/chat-flags';

export default {
  methods: {
    /**
     * Check user's postpaid electricity transaction state and SLA
     * @command - [apicall] checkPostpaidElectricityStateAndSLA [/apicall]
     * @param {object} currentTrx
     */
    async checkPostpaidElectricityStateAndSLA(currentTrx = {}) {
      const responses = {
        postpaidElectricityIsProcessedAndWithinSLA:
          '[apiresponse] postpaidElectricityIsProcessedAndWithinSLA [/apiresponse]',
        postpaidElectricityIsProcessedAndOutsideSLA:
          '[apiresponse] postpaidElectricityIsProcessedAndOutsideSLA [/apiresponse]',
        postpaidElectricityState: '[apiresponse] postpaidElectricityIs<state> [/apiresponse]',
        checkPostpaidElectricityStateAndSLAError:
          '[apiresponse] checkPostpaidElectricityStateAndSLAError [/apiresponse]',
      };

      try {
        if (!currentTrx) {
          this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
          return;
        }

        // Retrieve invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        // Retrieve Electricity Postpaid transaction data using transaction object from the invoice
        const { data: electricityPostpaidTrx } = await getElectricityPostpaidTransaction(this.$axios, invoiceTrx.id);

        const { state } = electricityPostpaidTrx;
        const createdAt = new Date(invoiceData.created_at);
        const dateNow = new Date();
        const oneDay = 24 * 60 * 60 * 1000;
        const SLA = dateNow - createdAt;
        const waitDate = createdAt.setDate(createdAt.getDate() + 1);

        /**
         * AC 1
         * state is "processed" and within SLA (under 1 day)
         */
        if (state === 'processed' && SLA < oneDay) {
          const msgPayload1 = {
            ...specialMessageSchema.generic,
            text: 'Maaf ya, juragan. Setelah Acha cek, transaksi juragan masih diproses',
          };
          const msgPayload2 = {
            ...specialMessageSchema.generic,
            text: `Harap tunggu hingga ${humanizeTimestamp(
              waitDate,
              '%dd% %month% %yyyy% pukul %hh%:%mi%'
            )} waktu setempat, ya!`,
          };

          this.sendMessage({
            msg: generateSpecialMessage(msgPayload1),
            nick: 'agent:trigger', // impersonate Acha Bot
            displayName: 'Acha',
          });
          this.sendMessage({
            msg: generateSpecialMessage(msgPayload2),
            nick: 'agent:trigger', // impersonate Acha Bot
            displayName: 'Acha',
          });
          this.$zopim.sendChatMsg(responses.postpaidElectricityIsProcessedAndWithinSLA);
          return;
        }

        /**
         * AC 2
         * state is 'processed' and outside SLA (more than or equals 1 day)
         */
        if (state === 'processed' && SLA >= oneDay) {
          this.$zopim.sendChatMsg(responses.postpaidElectricityIsProcessedAndOutsideSLA);
          return;
        }

        /**
         * AC 3
         * state is other than 'processed'
         */
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
        const finalResponse = responses.postpaidElectricityState.replace('<state>', capitalizedState);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkPostpaidElectricityStateAndSLAError);
        console.error('[ERROR] Something is wrong when trying to check Electricity Postpaid state and SLA', error);
      }
    },
  },
};
